import { useTranslation } from 'react-i18next'
import PlacowkaPicker from '@/widgets/PlacowkaPicker'

export default function AssignPlacowkaModal({ isOpen, onClose, onSelect, isAssigning = false }) {
	const { t } = useTranslation()

	if (!isOpen) return null

	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center p-4">
			<div className="absolute inset-0 bg-black/40" onClick={isAssigning ? undefined : onClose} />
			<div className="relative flex max-h-[90vh] w-full max-w-6xl flex-col overflow-hidden rounded-lg bg-white shadow-xl">
				<div className="flex items-start justify-between border-b border-gray-200 p-4">
					<div>
						<h3 className="text-base font-semibold text-gray-900">
							{t('korekty.list.assignPlacowkaModal.title')}
						</h3>
						<p className="mt-1 text-sm text-gray-500">
							{t('korekty.list.assignPlacowkaModal.description')}
						</p>
					</div>
					<button
						type="button"
						onClick={onClose}
						disabled={isAssigning}
						className="rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-60">
						{t('korekty.list.assignPlacowkaModal.close')}
					</button>
				</div>
				<div className="overflow-y-auto p-4">
					{isAssigning ? (
						<div className="py-8 text-center text-sm text-gray-500">
							{t('korekty.list.assignPlacowkaModal.assigning')}
						</div>
					) : (
						<PlacowkaPicker onPlacowkaSelect={onSelect} />
					)}
				</div>
			</div>
		</div>
	)
}
